import { render } from "./restartButton.vue?vue&type=template&id=5581d429"
import script from "./restartButton.vue?vue&type=script&lang=js"
export * from "./restartButton.vue?vue&type=script&lang=js"

import "./restartButton.vue?vue&type=style&index=0&id=5581d429&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__